<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="pencil (1) 1" clip-path="url(#clip0_3149_11113)">
      <path
        id="Vector"
        d="M11.0126 0.987649C10.6999 0.675387 10.276 0.5 9.83405 0.5C9.39211 0.5 8.96824 0.675387 8.65551 0.987649L1.17392 8.46939C0.959671 8.68244 0.789795 8.93586 0.674119 9.21498C0.558444 9.49411 0.499265 9.79341 0.500007 10.0956V11.04C0.500007 11.162 0.548472 11.279 0.63474 11.3653C0.721009 11.4515 0.838014 11.5 0.960016 11.5H1.90441C2.20653 11.5008 2.50582 11.4418 2.78494 11.3262C3.06407 11.2106 3.31749 11.0407 3.53055 10.8265L11.0126 3.34432C11.3247 3.0316 11.5 2.60782 11.5 2.16599C11.5 1.72415 11.3247 1.30037 11.0126 0.987649ZM2.88009 10.1761C2.62065 10.4338 2.2701 10.5789 1.90441 10.58H1.42002V10.0956C1.41956 9.91426 1.45506 9.73468 1.52446 9.5672C1.59387 9.39972 1.69581 9.24767 1.82437 9.11986L7.50226 3.44185L8.56028 4.49989L2.88009 10.1761ZM10.3617 2.69386L9.2089 3.84712L8.15088 2.79138L9.30412 1.63811C9.37359 1.56879 9.45603 1.51383 9.54674 1.47638C9.63745 1.43892 9.73465 1.41969 9.83279 1.4198C9.93093 1.41991 10.0281 1.43934 10.1187 1.477C10.2093 1.51465 10.2917 1.56979 10.361 1.63926C10.4303 1.70874 10.4853 1.79118 10.5227 1.88189C10.5602 1.97261 10.5794 2.06981 10.5793 2.16795C10.5792 2.26609 10.5598 2.36325 10.5221 2.45388C10.4844 2.54451 10.4293 2.62684 10.3598 2.69616L10.3617 2.69386Z"
        fill="#728599"
      />
    </g>
    <defs>
      <clipPath id="clip0_3149_11113">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
